export const CARGO_TYPES = {
  // ─── BULK LIQUIDS ──────────────────────────────────────
  crude_oil: {
    id: 'crude_oil',
    name: 'Crude Oil',
    category: 'bulk_liquid',
    basePrice: 5000,
    priceVolatility: 0.3,
    weightPerTEU: 20,
    perishable: false,
    dangerous: true,
    requiredShipCategories: ['tanker'],
    icon: 'oil.svg'
  },

  refined_oil: {
    id: 'refined_oil',
    name: 'Refined Petroleum',
    category: 'bulk_liquid',
    basePrice: 7000,
    priceVolatility: 0.25,
    weightPerTEU: 18,
    perishable: false,
    dangerous: true,
    requiredShipCategories: ['tanker'],
    icon: 'fuel.svg'
  },

  lng: {
    id: 'lng',
    name: 'Liquefied Natural Gas',
    category: 'bulk_liquid',
    basePrice: 10000,
    priceVolatility: 0.25,
    weightPerTEU: 10,
    perishable: false,
    dangerous: true,
    requiredShipCategories: ['tanker'],
    icon: 'lng.svg'
  },

  chemicals: {
    id: 'chemicals',
    name: 'Chemicals',
    category: 'bulk_liquid',
    basePrice: 6000,
    priceVolatility: 0.15,
    weightPerTEU: 18,
    perishable: false,
    dangerous: true,
    requiredShipCategories: ['tanker'],
    icon: 'chemicals.svg'
  },

  palm_oil: {
    id: 'palm_oil',
    name: 'Palm & Vegetable Oil',
    category: 'bulk_liquid',
    basePrice: 2000,
    priceVolatility: 0.2,
    weightPerTEU: 16,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['tanker'],
    icon: 'palm_oil.svg'
  },

  // ─── BULK DRY ──────────────────────────────────────────
  raw_materials: {
    id: 'raw_materials',
    name: 'Raw Materials',
    category: 'bulk_dry',
    basePrice: 800,
    priceVolatility: 0.2,
    weightPerTEU: 25,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'materials.svg'
  },

  minerals: {
    id: 'minerals',
    name: 'Mineral Ores',
    category: 'bulk_dry',
    basePrice: 1000,
    priceVolatility: 0.2,
    weightPerTEU: 22,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'minerals.svg'
  },

  timber: {
    id: 'timber',
    name: 'Timber & Lumber',
    category: 'bulk_dry',
    basePrice: 1000,
    priceVolatility: 0.15,
    weightPerTEU: 20,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'timber.svg'
  },

  grain: {
    id: 'grain',
    name: 'Wheat, Rice & Grain',
    category: 'bulk_dry',
    basePrice: 1100,
    priceVolatility: 0.2,
    weightPerTEU: 20,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'grain.svg'
  },

  cotton: {
    id: 'cotton',
    name: 'Raw Cotton',
    category: 'bulk_dry',
    basePrice: 1200,
    priceVolatility: 0.15,
    weightPerTEU: 8,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'cotton.svg'
  },

  steel: {
    id: 'steel',
    name: 'Steel & Iron Products',
    category: 'bulk_dry',
    basePrice: 1500,
    priceVolatility: 0.15,
    weightPerTEU: 22,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'steel.svg'
  },

  fertilizer: {
    id: 'fertilizer',
    name: 'Fertilizers',
    category: 'bulk_dry',
    basePrice: 900,
    priceVolatility: 0.15,
    weightPerTEU: 20,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'fertilizer.svg'
  },

  sugar: {
    id: 'sugar',
    name: 'Raw Sugar',
    category: 'bulk_dry',
    basePrice: 950,
    priceVolatility: 0.2,
    weightPerTEU: 18,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'sugar.svg'
  },

  coal: {
    id: 'coal',
    name: 'Coal',
    category: 'bulk_dry',
    basePrice: 500,
    priceVolatility: 0.15,
    weightPerTEU: 26,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'coal.svg'
  },

  cement: {
    id: 'cement',
    name: 'Cement & Building Materials',
    category: 'bulk_dry',
    basePrice: 650,
    priceVolatility: 0.1,
    weightPerTEU: 24,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'cement.svg'
  },

  coffee: {
    id: 'coffee',
    name: 'Coffee',
    category: 'bulk_dry',
    basePrice: 1500,
    priceVolatility: 0.2,
    weightPerTEU: 12,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'coffee.svg'
  },

  rubber: {
    id: 'rubber',
    name: 'Natural Rubber',
    category: 'bulk_dry',
    basePrice: 1200,
    priceVolatility: 0.15,
    weightPerTEU: 14,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'rubber.svg'
  },

  // ─── CONTAINER ─────────────────────────────────────────
  electronics: {
    id: 'electronics',
    name: 'Electronics',
    category: 'container',
    basePrice: 5000,
    priceVolatility: 0.15,
    weightPerTEU: 8,
    perishable: false,
    dangerous: false,
    fragile: true,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'electronics.svg'
  },

  textiles: {
    id: 'textiles',
    name: 'Textiles & Clothing',
    category: 'container',
    basePrice: 3000,
    priceVolatility: 0.2,
    weightPerTEU: 5,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'textiles.svg'
  },

  luxury_goods: {
    id: 'luxury_goods',
    name: 'Luxury Goods',
    category: 'container',
    basePrice: 20000,
    priceVolatility: 0.3,
    weightPerTEU: 4,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'luxury.svg'
  },

  spices: {
    id: 'spices',
    name: 'Spices',
    category: 'container',
    basePrice: 4000,
    priceVolatility: 0.15,
    weightPerTEU: 6,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'spices.svg'
  },

  gems: {
    id: 'gems',
    name: 'Gemstones & Precious Metals',
    category: 'container',
    basePrice: 25000,
    priceVolatility: 0.25,
    weightPerTEU: 2,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'gems.svg'
  },

  tea: {
    id: 'tea',
    name: 'Tea',
    category: 'container',
    basePrice: 2200,
    priceVolatility: 0.15,
    weightPerTEU: 8,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'tea.svg'
  },

  semiconductors: {
    id: 'semiconductors',
    name: 'Semiconductors',
    category: 'container',
    basePrice: 18000,
    priceVolatility: 0.2,
    weightPerTEU: 3,
    perishable: false,
    dangerous: false,
    fragile: true,
    requiredShipCategories: ['express'],
    icon: 'semiconductors.svg'
  },

  tobacco: {
    id: 'tobacco',
    name: 'Tobacco',
    category: 'container',
    basePrice: 3500,
    priceVolatility: 0.15,
    weightPerTEU: 8,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'tobacco.svg'
  },

  pharmaceuticals: {
    id: 'pharmaceuticals',
    name: 'Pharmaceuticals',
    category: 'container',
    basePrice: 15000,
    priceVolatility: 0.1,
    weightPerTEU: 4,
    perishable: false,
    dangerous: false,
    fragile: true,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'pharmaceuticals.svg'
  },

  plastics: {
    id: 'plastics',
    name: 'Plastics & Polymers',
    category: 'container',
    basePrice: 1800,
    priceVolatility: 0.15,
    weightPerTEU: 10,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'plastics.svg'
  },

  luxury_vehicles: {
    id: 'luxury_vehicles',
    name: 'Luxury & Sports Cars',
    category: 'container',
    basePrice: 35000,
    priceVolatility: 0.15,
    weightPerTEU: 8,
    perishable: false,
    dangerous: false,
    fragile: true,
    requiredShipCategories: ['cargo', 'express'],
    icon: 'luxury_vehicles.svg'
  },

  dried_fish: {
    id: 'dried_fish',
    name: 'Dried & Salted Fish',
    category: 'container',
    basePrice: 1200,
    priceVolatility: 0.15,
    weightPerTEU: 10,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo'],
    icon: 'dried_fish.svg'
  },

  wine: {
    id: 'wine',
    name: 'Wine & Spirits',
    category: 'container',
    basePrice: 6000,
    priceVolatility: 0.15,
    weightPerTEU: 14,
    perishable: false,
    dangerous: false,
    fragile: true,
    requiredShipCategories: ['cargo', 'specialized'],
    icon: 'wine.svg'
  },

  // ─── REFRIGERATED ──────────────────────────────────────
  meat: {
    id: 'meat',
    name: 'Meat & Poultry',
    category: 'refrigerated',
    basePrice: 3000,
    priceVolatility: 0.2,
    weightPerTEU: 12,
    perishable: true,
    perishDays: 14,
    dangerous: false,
    spoilageMultiplier: 0.5,
    requiredShipCategories: ['specialized'],
    icon: 'meat.svg'
  },

  fruit_vegetables: {
    id: 'fruit_vegetables',
    name: 'Fresh Produce',
    category: 'refrigerated',
    basePrice: 1800,
    priceVolatility: 0.25,
    weightPerTEU: 10,
    perishable: true,
    perishDays: 7,
    dangerous: false,
    spoilageMultiplier: 0.5,
    requiredShipCategories: ['cargo', 'specialized'],
    icon: 'fruit_vegetables.svg'
  },

  dairy: {
    id: 'dairy',
    name: 'Dairy Products',
    category: 'refrigerated',
    basePrice: 2500,
    priceVolatility: 0.2,
    weightPerTEU: 12,
    perishable: true,
    perishDays: 21,
    dangerous: false,
    spoilageMultiplier: 0.5,
    requiredShipCategories: ['specialized'],
    icon: 'dairy.svg'
  },

  frozen_goods: {
    id: 'frozen_goods',
    name: 'Frozen Goods',
    category: 'refrigerated',
    basePrice: 3500,
    priceVolatility: 0.2,
    weightPerTEU: 14,
    perishable: true,
    perishDays: 30,
    dangerous: false,
    requiredShipCategories: ['specialized'],
    icon: 'frozen.svg'
  },

  medical: {
    id: 'medical',
    name: 'Medical Supplies',
    category: 'refrigerated',
    basePrice: 12000,
    priceVolatility: 0.1,
    weightPerTEU: 6,
    perishable: true,
    perishDays: 60,
    dangerous: false,
    requiredShipCategories: ['specialized', 'express'],
    icon: 'medical.svg'
  },

  seafood: {
    id: 'seafood',
    name: 'Fresh Seafood',
    category: 'refrigerated',
    basePrice: 4000,
    priceVolatility: 0.25,
    weightPerTEU: 10,
    perishable: true,
    perishDays: 10,
    dangerous: false,
    spoilageMultiplier: 0.5,
    requiredShipCategories: ['specialized'],
    icon: 'seafood.svg'
  },

  // ─── RO-RO ─────────────────────────────────────────────
  automobiles: {
    id: 'automobiles',
    name: 'Passenger Vehicles',
    category: 'ro_ro',
    basePrice: 12000,
    priceVolatility: 0.12,
    weightPerTEU: 12,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'specialized'],
    icon: 'automobiles.svg'
  },

  trucks: {
    id: 'trucks',
    name: 'Trucks & Heavy Vehicles',
    category: 'ro_ro',
    basePrice: 10000,
    priceVolatility: 0.1,
    weightPerTEU: 18,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'specialized'],
    icon: 'trucks.svg'
  },

  machinery: {
    id: 'machinery',
    name: 'Industrial Machinery',
    category: 'ro_ro',
    basePrice: 8000,
    priceVolatility: 0.1,
    weightPerTEU: 15,
    perishable: false,
    dangerous: false,
    requiredShipCategories: ['cargo', 'specialized'],
    icon: 'machinery.svg'
  }
};

export const CARGO_CATEGORIES = {
  bulk_liquid:   { name: 'Bulk Liquid',       requiresSpecialShip: true  },
  bulk_dry:      { name: 'Bulk Dry',          requiresSpecialShip: false },
  container:     { name: 'Container',         requiresSpecialShip: false },
  refrigerated:  { name: 'Refrigerated',      requiresSpecialShip: true  },
  ro_ro:         { name: 'Roll-on/Roll-off',  requiresSpecialShip: false }
};

export function getCargoType(id) {
  return CARGO_TYPES[id] || null;
}

/**
 * Check if a ship type can carry a given cargo type.
 * Both the cargo's required ship categories AND the ship's cargo restrictions must agree.
 */
export function canShipCarryCargo(shipType, cargoId) {
  if (!shipType) return false;
  const cargoDef = CARGO_TYPES[cargoId];
  if (!cargoDef) return false;

  // Check 1: cargo requires specific ship categories
  if (cargoDef.requiredShipCategories && !cargoDef.requiredShipCategories.includes(shipType.category)) {
    return false;
  }

  // Check 2: ship has a cargo whitelist
  if (shipType.cargoRestrictions && !shipType.cargoRestrictions.includes(cargoId)) {
    return false;
  }

  return true;
}
